import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import Modal from '../../Components/Modal/Modal';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './OrderHistory.scss';

const statusList = {
    Pending : '처리중',
    Done : '주문완료',
    Canceled : '주문취소',
    CancelAccept : '주문취소',
    Reject : '주문거절'
}

const variant = {
    Pending : 'primary',
    Done : 'normal',
    Canceled : 'danger',
    CancelAccept : 'danger',
    Reject : 'danger'
}

const orderType = {
    Pickup : '포장',
    Delivery : '배달',
    Table : '테이블'
}

const OrderHistory = () => {
    const modalRef = React.useRef(null);
    const [ data, setData ] = React.useState({})

    const columns = React.useMemo(
        () => [
          {
            /* Header: '메뉴를 검색해보세요.', */
            Header: '메뉴',
            accessor: 'DisplayName', // accessor is the "key" in the data
            disableSortBy : true,
            Cell : (props) => {
              return (
                <p className='table-title'>{props.cell.value}</p>
              )
            },
            width : 300,
            minWidth : 300
          },
          {
            Header: '결제금액',
            accessor: 'PaymentPrice',
            disableFilters : true,
            minWidth : 120,
            maxWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                    <p>{convertCost(props.cell.value)}원</p>
                )
            }
          },
          {
            Header: '주문방식',
            accessor: 'OrderType',
            disableFilters : true,
            minWidth : 120,
            maxWidth : 120,
            width : 120,
            Cell : (props) => {
                return(
                    <p>{orderType[props.cell.value]}</p>
                )
            }
          },
          {
            Header: '주문일시',
            accessor: 'OrderDate.$date',
            disableFilters : true,
            minWidth : 150,
            width : 150,
            Cell : (props) => {
                return(
                    <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                )
            }
          },
          {
            Header: '유저번호',
            accessor: 'UserInfo',
            disableSortBy : true,
            minWidth : 144,
            width : 144,
            Cell : (props) => {
                if(typeof props.cell.value !== 'undefined'){
                    return(
                        <Link to={`/user-info/${props.cell.value._id.$oid}`}>
                            <p style={{ color : '#f95f53'}}>{props.cell.value.Tel}</p>
                        </Link>    
                    )
                }else {
                    return(
                        <p style={{ color : '#f95f53'}}>탈퇴한 회원</p>
                    )
                }
            }
          },
          {
            Header: '상태',
            accessor: 'Status',
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            Cell : (props) => {
                return(
                    <StatusBadge Status={statusList[props.cell.value]} variant={variant[props.cell.value]}/>
                )
            },
            minWidth : 144,
            width : 144
          },
        ]
    )

    return (
        <div className='order-history'>
            <Table columns={columns} url={'/api/history/order'} onRowClick={(data) => {setData(data); modalRef.current.openModal() }}/>
            <Modal ref={modalRef} onBackdropClick={() => modalRef.current.closeModal()}>
                <div >
                    {
                        Object.keys(data).length > 0 &&
                        <>
                            <div className='row' style={{ alignItems : 'flex-start', marginBottom : 40 }}>
                                <p className='modal-header'>주문 상세 내역을<br/>확인해보세요.</p>
                                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24 }} onClick={() => modalRef.current.closeModal()}/>
                            </div>

                            <div className='row'>
                                {
                                    data.Status === 'Pending' && <p className='primary-text'>접수 대기중이에요.</p>
                                }
                                {
                                    data.Status === 'Done' && <p className='done-text'>주문이 완료되었어요.</p>
                                }
                                {
                                    (data.Status === 'Reject' || data.Status.includes('Cancel') ) && <p className='canceled-text'>{data.Reason}</p>
                                }
                                <StatusBadge Status={statusList[data.Status]} variant={variant[data.Status]} />
                            </div>
                            <p className='info-header'>주문정보</p>
                            <div className='row'>
                                <p className='info-title'>주문일시</p>
                                <p className='info-text'>{moment(data.OrderDate.$date).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>주문번호</p>
                                <p className='info-text'>{data.Seed}</p>
                            </div>
                            <div className='row'>
                                <p className='info-title'>주문방식</p>
                                <p className='info-text'>{orderType[data.OrderType]}</p>
                            </div>
                            {
                                typeof data.UserInfo === 'undefined' ?
                                <div className='row'>
                                    <p className='info-title'>유저번호</p>
                                    <p style={{ color : '#f95f53'}} className='info-text'>탈퇴한 회원</p>
                                </div>
                                :
                                <div className='row'>
                                    <p className='info-title'>유저번호</p>
                                    <p className='info-text'>{data.UserInfo.Tel}</p>
                                </div>
                            }
                            

                            <div className='row'>
                                <p className='info-title'>메뉴명</p>
                                <p className='info-text'>{data.DisplayName}</p>
                            </div>

                            <div className='line'/>

                            <p className='info-header'>결제정보</p>
                            <div className='row'>
                                <p className='info-title-bold'>총 금액</p>
                                <p className='info-text-bold'>{convertCost(data.Price + data.DeliveryFee)}원</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>주문금액</p>
                                <p className='info-text'>{convertCost(data.Price)}원</p>
                            </div>
                            
                            {
                                data.OrderType === 'Delivery' &&
                                <div className='row'>
                                    <p className='info-title'>배달팁</p>
                                    <p className='info-text'>{convertCost(data.DeliveryFee)}원</p>
                                </div>
                            }

                            <div className='row'>
                                <p className='info-title-point'>사용포인트</p>
                                <p className='info-text-point'>-{convertCost(data.usePoint)} P</p>
                            </div>

                            <div className='row'>
                                <p className='info-title-bold'>결제금액</p>
                                <p className='info-text-bold'>{convertCost(data.PaymentPrice)} 원</p>
                            </div>

                            <div className='row'>
                                <p className='info-title'>적립포인트</p>
                                <p className='info-text'>{convertCost(data.pendingPoint)} P</p>
                            </div>
                        </>
                    }
                    
                </div>
            </Modal>
        </div>
    )
}

export default OrderHistory;